<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-data
          titulo="Información del Tipo de Diseño"
          :datos="tipoDisenioDatos">
        </app-data>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Tipo de Diseño</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tipoDisenio/getField',
  mutationType: 'tipoDisenio/updateField',
});

export default {
  name: 'TipoDisenioData',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id
    
    this.tableBusy = true;
    this.$store.dispatch('tipoDisenio/getDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'tipoDisenioDatos',
    ]),
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'TiposDisenios' }); 
    },
    editar() {
      this.$router.push({ name: 'TipoDisenioEdit', 
                          params: { id: this.id }})
    },
  }
}
</script>
